const tables = [
  {
    name: "Number",
  },
  {
    name: "Customer",
  },
  {
    name: "Date",
  },
  // {
  //   name: "Due",
  // },
  {
    name: "Billed By",
  },
  {
    name: "Delivery",
  },
  {
    name: "Payment",
  },
  // {
  //   name: "Status",
  // },
  {
    name: "Total",
  },
  // {
  //   name: "Action",
  // },
];

export default tables;
